import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface UpdateCustomerRequest {
    union_option: boolean;
    default_sender: string;
    union_sender: string;
    status: boolean;
}

export const usePutCustomerSender = (
    successCallback?: () => void,
    customerId?: number,
    senderId?: number,
): UseMutationResult<null, Error, UpdateCustomerRequest> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, UpdateCustomerRequest>({
        mutationFn: async (customerSenderData: UpdateCustomerRequest) => {
            const response = await axios.put(
                enum_api_uri.put_customer_sender
                    .replace(":customer_idx", customerId?.toString() || "")
                    .replace(":sender_idx", senderId?.toString() || ""),
                customerSenderData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerSender"] });
            successCallback?.();
        },
    });
};
